<template>
  <dara-single-content-layout v-loading="fullscreenLoading" container-size="lg">
    <template #content>
      <dara-header>
        {{ $t('current-podium') }} <dara-small>({{ $t('referring-to') }} {{ currentMonthName }} {{ currentYear }})</dara-small>
      </dara-header>

      <dara-p class="mb--xl dara-u-text--medium">
        {{ $t('ranking-page-description-1') }}<br>
        {{ $t('ranking-page-description-2') }}
      </dara-p>

      <dara-row class="mt--xl mb--xl d-flex justify-content-center justify-content--space-between">
        <dara-col :xs="24" :span="8" class="gray-card">
          <dara-p v-truncate weight="strong" margin="sm">
            {{ $t('best-writer') }}
          </dara-p>
          <dara-small>{{ $t('best-writer-description') }}</dara-small>
          <dara-user-resume v-if="bestWriter" ref="bestWriter" class="mt--lg" :can-follow="false" :user="bestWriter" @reloadUser="updateFeaturedUsers" />
          <dara-header v-else size="sm" class="mt--lg color--info">
            {{ $t('there-is-no-best-writer-yet') }}
          </dara-header>
        </dara-col>
        <dara-col :xs="24" :span="8" class="gray-card">
          <dara-p v-truncate weight="strong" margin="sm">
            {{ $t('top-writer') }}
          </dara-p>
          <dara-small>{{ $t('top-writer-description') }}</dara-small>
          <dara-user-resume v-if="topWriter" ref="topWriter" class="mt--lg" :can-follow="false" :user="topWriter" @reloadUser="updateFeaturedUsers" />
          <dara-header v-else size="sm" class="mt--lg color--info">
            {{ $t('there-is-no-top-writer-yet') }}
          </dara-header>
        </dara-col>
        <dara-col :xs="24" :span="8" class="gray-card">
          <dara-p v-truncate weight="strong" margin="sm">
            {{ $t('top-reader') }}
          </dara-p>
          <dara-small>{{ $t('top-reader-description') }}</dara-small>
          <dara-user-resume v-if="topReader" ref="topReader" class="mt--lg" :can-follow="false" :user="topReader" @reloadUser="updateFeaturedUsers" />
          <dara-header v-else size="sm" class="mt--lg color--info">
            {{ $t('there-is-no-top-reader-yet') }}
          </dara-header>
        </dara-col>
      </dara-row>

      <dara-user-ranking-table />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';

import { fetchBestWriters, fetchTopReaders, fetchTopWriters } from '@/modules/user/user.service';

import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';
import DaraUserResume from '@/modules/user/components/UserResume.vue';
import DaraUserRankingTable from '@/modules/user/components/UserRankingTable.vue';

export default {
  name: 'DaraRankingPage',
  components: {
    DaraSingleContentLayout,
    DaraUserResume,
    DaraUserRankingTable,
  },
  data() {
    return {
      fullscreenLoading: true,
      bestWriter: null,
      topWriter: null,
      topReader: null,

      date: new Date(),
      currentMonthName: null,
      currentYear: null,
      monthNames: ['january', 'february', 'march', 'april', 'may', 'june',
        'july', 'august', 'september', 'october', 'november', 'december'],
    };
  },
  created() {
    let currentMonth = 0;
    this.currentYear = this.date.getFullYear();
    if (this.date.getMonth() === 0) {
      currentMonth = 11;
      this.currentYear = this.date.getFullYear() - 1;
    } else {
      currentMonth = this.date.getMonth() - 1;
    }
    this.currentMonthName = translate(this.monthNames[currentMonth]);
  },
  mounted() {
    this.fetchFeaturedUsers();
  },
  methods: {
    fetchFeaturedUsers() {
      this.fetchBestWriter();
      this.fetchTopWriter();
      this.fetchTopReader();
    },
    fetchBestWriter() {
      fetchBestWriters(1)
        .then(user => {
          if (user) {
            user.badge = 'best-writer';
            this.bestWriter = user;
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-best-writer')}`);
          this.bestWriter = null;
        });
    },
    fetchTopWriter() {
      fetchTopWriters(1)
        .then(user => {
          if (user) {
            user.badge = 'top-writer';
            this.topWriter = user;
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-writer')}`);
          this.topWriter = null;
        });
    },
    fetchTopReader() {
      fetchTopReaders(1)
        .then(user => {
          if (user) {
            user.badge = 'top-reader';
            this.topReader = user;
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-reader')}`);
          this.topReader = null;
        });
    },
    updateFeaturedUsers(user) {
      // re-rendering featured users
      if (user.id === this.bestWriter.id) {
        this.bestWriter = null;
        this.fetchBestWriter();
      }
      if (user.id === this.topWriter.id) {
        this.topWriter = null;
        this.fetchTopWriter();
      }
      if (user.id === this.topReader.id) {
        this.topReader = null;
        this.fetchTopReader();
      }
    },
  },
};
</script>

<style scoped>
  .gray-card {
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-top: 20px solid transparent;
    border-bottom : 20px solid transparent;
    border-radius: 5px;
    margin: 0rem 0.6rem 0rem 0.6rem;
    background-color: #f4f4f5 !important;
  }
</style>
